// extracted by mini-css-extract-plugin
export var productSpecialFeatures = "ProductSpecialFeatures-module--productSpecialFeatures--h+vDg";
export var inner = "ProductSpecialFeatures-module--inner--cJkhK";
export var specialFeatures = "ProductSpecialFeatures-module--specialFeatures--B0ZCh";
export var imageContainer = "ProductSpecialFeatures-module--imageContainer--iSaeh";